//----------PRODUCCION-------------
import ControlTiemposMuertos from "../../../views/administrador/Produccion/ControlTiemposMuertos";



const routes_produccion = [
  {
    path: "/ControlTiemposMuertos",
    name: "Tiempos Muertos",
    icon: "",
    component: ControlTiemposMuertos,
    doNotShow: true,
  }, 
];

export default routes_produccion;
